import { render, staticRenderFns } from "./modalAddress.vue?vue&type=template&id=3bc00732"
import script from "./modalAddress.vue?vue&type=script&lang=js"
export * from "./modalAddress.vue?vue&type=script&lang=js"
import style0 from "./modalAddress.vue?vue&type=style&index=0&id=3bc00732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports